module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/index-36.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/lab/index.md
// module id = 117
// module chunks = 3